export const baseUrl = 'https://backend-prod-254015706580.asia-south2.run.app';
// export const baseUrl = 'http://127.0.0.1:8000';
// export const baseUrl = 'https://lmsapi.yallas.tech';
